import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import classes from "./const";
import functions from "./functions";

gsap.registerPlugin(ScrollTrigger);

const prepHeaderChangeBySection = (
  tl,
  classname,
  type,
  handleChangeHeaderType
) => {
  tl.to(classname, {
    scrollTrigger: {
      trigger: classname,
      start: "top top",
      end: "bottom bottom",
      onEnter: () => {
        handleChangeHeaderType(type);
      },
      onEnterBack: () => {
        handleChangeHeaderType(type);
      },
    },
  });
};

const header = (handleChangeHeaderType) => {
  const tl = gsap;
  prepHeaderChangeBySection(tl, ".mission", "default", handleChangeHeaderType);
  prepHeaderChangeBySection(tl, ".gallery", "gallery", handleChangeHeaderType);
  prepHeaderChangeBySection(tl, ".match", "match", handleChangeHeaderType);
  // prepHeaderChangeBySection(tl, ".proof", "proof", handleChangeHeaderType);
  tl.to(".footer", {
    scrollTrigger: {
      trigger: ".footer",
      start: "top top",
      onEnter: () => {
        handleChangeHeaderType("");
      },
    },
  });
};

const starting = (isPopup) => {
  const tl = gsap;

  window.scrollTo(0, 0);
  tl.to("html", {
    overflowY: "hidden",
  });

  console.log("isPopup", isPopup);
  if (isPopup) {
    tl.to(".main", 0, { delay: 2, opacity: 1 });

    tl.to(classes.starting.logo, 0, { opacity: 0 });
    tl.to(classes.main.content, 0, {
      transform: "translateX(0vw)",
    });
    tl.to(classes.header.main, 0, {
      transform: "translateY(0vw)",
      opacity: 1,
    });
    tl.to("html", {
      overflowY: "hidden",
    });

    // tl.to(".mission__text--1st", 0, {
    //   transform: "translateY(0vh)",
    //   opacity: 1,
    // });

    // gsap.to(classes.mission.top.text1_1, {
    //   scrollTrigger: {
    //     trigger: classes.mission.top.text1_1,
    //     start: "top bottom",
    //   },
    // });
  } else {
    tl.to(".main", 0, { opacity: 1 });
    tl.to(classes.starting.logo, 2, { opacity: 1 });
    tl.to(classes.starting.logo, 0.5, { delay: 2, opacity: 0 });
    tl.to(classes.main.content, 0.5, {
      delay: 2,
      transform: "translateX(0vw)",
    });
    tl.to(classes.header.main, 0.5, {
      delay: 2.5,
      transform: "translateY(0vw)",
      opacity: 1,
    });
    tl.to("html", {
      delay: 3,
      overflowY: "scroll",
    });

    // tl.to(".mission__text--1st", 0.3, {
    //   delay: 2.5,
    //   transform: "translateY(0vh)",
    //   opacity: 1,
    // });

    // gsap.to(classes.mission.top.text1_1, {
    //   scrollTrigger: {
    //     trigger: classes.mission.top.text1_1,
    //     start: "top bottom",
    //   },
    // });
  }
};

const mission = () => {
  functions.showText(classes.mission.top.text1_2);
  functions.showText(classes.mission.bottom.text1_1);
  functions.showText(classes.mission.bottom.text1_2);

  // gsap.to(".mission__image-wrapper", {
  //   scrollTrigger: {
  //     trigger: classes.mission.bottom.bg,
  //     start: "top center",
  //     // markers: true,
  //     toggleClass: "mission__image--shapes-animate",
  //   },
  // });
};

const match = () => {
  gsap.to(".match__image-wrapper", {
    transform: "translateY(0vw)",
    scrollTrigger: {
      trigger: ".match__image-wrapper",
      start: "top+100vh center",
      // markers: true,
      scrub: true,
    },
  });

  setTimeout(() => {
    gsap.to(".match__image--phone", {
      transform: `translateY(-150vh)`,
      scrollTrigger: {
        trigger: ".match",
        start:
          window.innerHeight > window.innerWidth ? `top center` : `top top`,
        scrub: true,
      },
    });
  }, 1000);

  functions.showText(classes.match.text.text1_1);
  functions.showText(classes.match.text.text1_2);
  functions.showText(classes.match.button);
  functions.showText(classes.match.toolbar);
};

const gallery = () => {
  //tablet
  // gsap.to(".gallery__tablet", {
  //   opacity: 1,
  //   zIndex: 0,
  //   scrollTrigger: {
  //     trigger: classes.gallery.text.text1_3,
  //     start: "top top",
  //     end: "top+=30% top",
  //     // markers: true,
  //     scrub: true,
  //   },
  // });

  // gsap.to(".gallery__tablet", {
  //   opacity: 1,
  //   transform: 'translate(-50%) scale(1)',
  //   scrollTrigger: {
  //     trigger: classes.gallery.text.text1_5,
  //     start: "top top",
  //     end: "top+=30% top",
  //     // markers: true,
  //     scrub: true,
  //   },
  // });

  gsap.to(".gallery__image-wrapper", {
    transform: "translateY(0vh)",
    scrollTrigger: {
      trigger: ".gallery__image-wrapper",
      start: "top+200vh center",
      end: "bottom-=200vh top",
      // markers: true,
      scrub: true,
    },
  });

  functions.showText(classes.gallery.text.text1_1);
  functions.showText(classes.gallery.text.text1_2);
  functions.showText(classes.gallery.text.text1_3);
  functions.showText(classes.gallery.text.text1_4);
  // functions.showText(classes.gallery.text.text1_5);
  // functions.showText(classes.gallery.text.text1_6);
  // functions.showText(classes.gallery.text.text1_7);
  // functions.showText(classes.gallery.button);
  functions.showText(classes.gallery.toolbar);
};

// const proof = () => {
//   gsap.to(".proof__image-wrapper", {
//     transform: "translate(0vw, 0vw)",
//     scrollTrigger: {
//       trigger: ".proof__image-wrapper",
//       start: "top+100vh center",
//       // markers: true,
//       scrub: true,
//     },
//   });

//   functions.showText(classes.proof.text.text1_1);
//   functions.showText(classes.proof.text.text1_2);
//   functions.showText(classes.proof.button);
// };

const galleries = () => {
  gsap.to(".galleries", {
    transform: "translateY(0vw)",
    scrollTrigger: {
      trigger: ".galleries",
      start: "top+100vh center",
      // markers: true,
      scrub: true,
    },
  });
};

const openPrivacy = () => {
  document.querySelector(".privacy").scrollTo(0, 0);

  gsap.to("html", {
    overflowY: "hidden",
  });
  gsap.to(".privacy__close", 0.3, {
    zIndex: 12,
    opacity: 1,
  });
};

const closePrivacy = () => {
  gsap.to("html", {
    overflowY: "scroll",
  });

  gsap.to(".privacy__close", 0.2, {
    opacity: 0,
    zIndex: -1,
  });
};

export default {
  galleries,
  mission,
  starting,
  match,
  gallery,
  // proof,
  openPrivacy,
  closePrivacy,
  header,
};
